import { render } from "./DonutYesNoChart.vue?vue&type=template&id=631e3d8e"
import script from "./DonutYesNoChart.vue?vue&type=script&lang=js"
export * from "./DonutYesNoChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__